export default {
  type: "photography",
  img: "Bolivia.jpg",
  id: 'photography_Bolivia',
  new: false,
  text: {
    title: "Terra (Inca)gnita",
    description: "A collection of photographies taken during a trip to Bolivia."
  }
};
